// Variant registry keeps variants data-driven; adding one requires updating the type, config, and record, enforced by TypeScript.

import type { ComponentType } from "react";
import { CalendarPanel } from "./panels/CalendarPanel";
import { DateTimePanel, TimeFieldPanel } from "./panels/DateTimePanel";
import { TimeStepperPanel } from "./panels/TimeStepperPanel";
import type { DateTimePickerPanelProps } from "./panels/panelTypes";
import { VARIANT_CONFIG, type VariantConfig } from "./variantConfig";
import type { DateTimePickerVariant } from "./types";

export interface VariantEntry extends VariantConfig {
  Panel: ComponentType<DateTimePickerPanelProps>;
}

export const VARIANT_REGISTRY: Record<DateTimePickerVariant, VariantEntry> = {
  single: { ...VARIANT_CONFIG.single, Panel: CalendarPanel },
  range: { ...VARIANT_CONFIG.range, Panel: CalendarPanel },
  multiple: { ...VARIANT_CONFIG.multiple, Panel: CalendarPanel },
  time: { ...VARIANT_CONFIG.time, Panel: TimeFieldPanel },
  "time-stepper": { ...VARIANT_CONFIG["time-stepper"], Panel: TimeStepperPanel },
  datetime: { ...VARIANT_CONFIG.datetime, Panel: DateTimePanel },
};

export type { DateTimePickerPanelProps } from "./panels/panelTypes";
